


































import { Audit } from "../../models/Audit";
import Evenement = Audit.Evenement;
import ContactSelect from "../../core/Forms/ContactSelect.vue";
import InputField from "../../core/Forms/InputField.vue";
import TextareaInput from "../../core/Forms/TextareaInput.vue";
import PhotosViewer from "../../core/Files/PhotosViewer.vue";

export default {
    name: "EvenementModalEdit",
    components: { PhotosViewer, TextareaInput, InputField, ContactSelect },
    props: {
        evenement: Evenement,
    },
};
